import ExpandedView from '@cp/src/components/ExpandedView/ExapndedView';
import { useState } from 'react';
import BankStatement from './BankStatement';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';

const BankStatementView = () => {
  const [isExpandedView, setIsExpandedView] = useState(false);
  addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_DOCUMENTS_BANK_STATEMENT_PAGE_LAND);

  return (
    <>
      {isExpandedView ? (
        <ExpandedView
          isHeaderRequired={false}
          visible={true}
          onClose={() => {
            setIsExpandedView(false);
          }}
        >
          <BankStatement isOnModal={true} setIsExpandedView={setIsExpandedView} />
        </ExpandedView>
      ) : (
        <BankStatement isOnModal={false} setIsExpandedView={setIsExpandedView} />
      )}
    </>
  );
};

export default BankStatementView;
